import { HttpClient } from '@angular/common/http';
import { SiteSetupService } from 'app/client-core/services/site-setup';
import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { Observable } from 'rxjs/Observable';
import { AuthToken } from "./auth.token";
import { AuthUser } from "./auth.user";
import { ApiResponse } from '../client-core/api-response-models';
import { ApiService } from '../client-core/api.service';
import * as moment from 'moment'
import { UserService } from 'app/client-core/services/user.service';

@Injectable()
export class AuthService {

    redirectUrl: string;

    constructor(
        private router: Router,
        private apiService: ApiService,
        private userService: UserService,
        private siteSetup: SiteSetupService,
        private http: HttpClient
    ) { }

    private startNewUserSession(): void {
        localStorage.removeItem("token");
        localStorage.removeItem("claims");
        localStorage.removeItem("site_config");
    }

    private endUserSession(): void {
        this.startNewUserSession();
    }

    // login(authUser: AuthUser): Observable<ApiResponse<AuthToken>> | boolean {
    login(authUser: AuthUser): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.startNewUserSession();
            return this.apiService.postAuth('auth/token', authUser)
                .subscribe(res => {
                    authUser.clearSensitiveData();
                    console.log('setting localstorage for token', res.data);
                    localStorage.setItem('token', JSON.stringify(res.data));

                    this.trackLoginLogout({type: 1, token: res.data.token}).subscribe((response) => {
                        console.log(response);
                        if ((response as any).data.success) {
                            authUser.clearSensitiveData();
                            if (!res.hasError && res.data && res.data.token) {
                                this.userService.getClaims().subscribe(() => {
                                    const promisses = [
                                        this.siteSetup.getSiteMenus(1),
                                        this.userService.getClientSettings(true)
                                    ];
                                    Promise.all(promisses as any).then(() => {
                                        resolve(true);
                                    })
                                    // this.siteSetup.getSiteMenus(1).then(() => {
                                    //     resolve(true);
                                    // });
                                })
                            } else {
                                resolve(false)
                            }
                        } else {
                            localStorage.removeItem('token');
                            resolve(false)
                        }
                    }, (error) => {
                        console.log('setting localstorage for token', error);
                        localStorage.removeItem('token');
                        reject(error);
                    });
                }, error => {
                    console.log('setting localstorage for token', error);
                    localStorage.removeItem('token');
                    reject(error);
                });
        });
    }

    register(authUser: AuthUser): Observable<ApiResponse<AuthToken>> {
        return this.apiService.post<AuthToken>('auth/register', authUser)
            .do(res => {

            });
    }

    getAuthHeader(): string {
        if (!this.getIsLoggedIn())
            return null;

        let authToken = this._getAuthToken();
        if (authToken) {
            return `bearer ${authToken.token}`;
        }

        return null;
    }

    redirectAfterAuth(): void {
        const url = this.redirectUrl ? this.redirectUrl : "/";

        this.userService.getSiteConfig().subscribe(() => {
            this.userService.getFirstRoute().subscribe(data => {
                if (data.data) {
                    location.href = data.data
                } else {
                    this.router.navigate([url]);
                }
            });
        })
    }

    trackLoginLogout(params?, postOptions?) {
        let token = "";
        if (this._getAuthToken()) {
            token = this._getAuthToken().token;
        }

        return this.apiService.post('users/tracklogin', {
            token: token,
            type: 2,
            url: location.href,
            ...params
        }, postOptions);
    }

    logout(): void {
        this.log('logging out');

        this.endUserSession();
        try {
            // this.apiService.delete('auth').subscribe();
        } catch (error) {
            console.log(">>logout", error);
        }

        this.router.navigate(['auth/login']);
    }

    getIsLoggedIn(): boolean {
        let authToken = this._getAuthToken();
        if (authToken) {
            let expiresOn = moment.parseZone(authToken.expiration);
            if (expiresOn.isValid && expiresOn.isAfter(moment())) {
                return true;
            }
        }

        return false;
    }

    private log(message: string) {
        //this.messageService.add('HeroService: ' + message);        
        console.log('Message received: ', message);
    }

    private _getAuthToken(): AuthToken {
        let token = localStorage.getItem('token');
        if (token) {
            let authToken: AuthToken = JSON.parse(token);
            return authToken;
        }

        return null;
    }

    changePassword(authUser: AuthUser): Observable<ApiResponse<any>> {
        console.log(`changing password for ${authUser.username}`);
        return this.apiService.postChangePwd('auth/ChangePwd', authUser)
            .do(res => {
                console.log(res);
            });
    }

    getLoginMessage(): Promise<String> {
        return new Promise<String>((resolve, reject) => {
            this.http.get('/api/loginmessage').subscribe(response => {
                resolve((response as any).data);
            }, error => {
                reject(error);
            });
        })
    };

    setSiteName(sitename) {
        localStorage.setItem('site_name', sitename);
    }

    getSiteName() {
        return localStorage.getItem('site_name');
    }

    getSiteNameFromApi() {
        return new Promise((resolve, reject) => {
            this.http.get('/api/sitename').subscribe(response => {
                resolve(response);
            })
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/+auth/auth.service.ts